import _isFunction from "lodash/isFunction";
import _noop from "lodash/noop";
import _isString from "lodash/isString";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && _indexOfInstanceProperty(e).call(e, p) < 0) t[p] = s[p];

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (_indexOfInstanceProperty(e).call(e, p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable no-unused-vars, max-len, @typescript-eslint/no-unused-vars */


import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import InputFoundation from '@douyinfe/semi-foundation/lib/es/input/foundation';
import { cssClasses, strings } from '@douyinfe/semi-foundation/lib/es/input/constants';
import { isSemiIcon } from '../_utils';
import BaseComponent from '../_base/baseComponent';
import '@douyinfe/semi-foundation/lib/es/input/input.scss';
import { IconClear, IconEyeOpened, IconEyeClosedSolid } from '@douyinfe/semi-icons';
const prefixCls = cssClasses.PREFIX;
const sizeSet = strings.SIZE;
const statusSet = strings.STATUS;
const modeSet = strings.MODE;

class Input extends BaseComponent {
  constructor(props) {
    super(props);

    this.handleClear = e => {
      this.foundation.handleClear(e);
    };

    this.handleClearEnterPress = e => {
      this.foundation.handleClearEnterPress(e);
    };

    this.handleClick = e => {
      this.foundation.handleClick(e);
    };

    this.handleMouseOver = e => {
      this.setState({
        isHovering: true
      });
    };

    this.handleMouseLeave = e => {
      this.setState({
        isHovering: false
      });
    };

    this.handleModeChange = mode => {
      this.foundation.handleModeChange(mode);
    };

    this.handleClickEye = e => {
      this.foundation.handleClickEye(e);
    };

    this.handleMouseDown = e => {
      this.foundation.handleMouseDown(e);
    };

    this.handleMouseUp = e => {
      this.foundation.handleMouseUp(e);
    };

    this.handleModeEnterPress = e => {
      this.foundation.handleModeEnterPress(e);
    };

    this.handleClickPrefixOrSuffix = e => {
      this.foundation.handleClickPrefixOrSuffix(e);
    };

    this.handlePreventMouseDown = e => {
      this.foundation.handlePreventMouseDown(e);
    };

    this.state = {
      value: '',
      cachedValue: null,
      disabled: false,
      props: {},
      paddingLeft: '',
      isFocus: false,
      isHovering: false,
      eyeClosed: props.mode === 'password',
      minLength: props.minLength
    };
    this.inputRef = /*#__PURE__*/React.createRef();
    this.prefixRef = /*#__PURE__*/React.createRef();
    this.suffixRef = /*#__PURE__*/React.createRef();
    this.foundation = new InputFoundation(this.adapter);
  }

  get adapter() {
    return _Object$assign(_Object$assign({}, super.adapter), {
      setValue: value => this.setState({
        value
      }),
      setEyeClosed: value => this.setState({
        eyeClosed: value
      }),
      toggleFocusing: isFocus => {
        const input = this.inputRef && this.inputRef.current;

        if (isFocus) {
          input && input.focus();
        } else {
          input && input.blur();
        }

        this.setState({
          isFocus
        });
      },
      toggleHovering: isHovering => this.setState({
        isHovering
      }),
      getIfFocusing: () => this.state.isFocus,
      notifyChange: (cbValue, e) => this.props.onChange(cbValue, e),
      notifyBlur: (val, e) => this.props.onBlur(e),
      notifyFocus: (val, e) => this.props.onFocus(e),
      notifyInput: e => this.props.onInput(e),
      notifyKeyPress: e => this.props.onKeyPress(e),
      notifyKeyDown: e => this.props.onKeyDown(e),
      notifyKeyUp: e => this.props.onKeyUp(e),
      notifyEnterPress: e => this.props.onEnterPress(e),
      notifyClear: e => this.props.onClear(e),
      setPaddingLeft: paddingLeft => this.setState({
        paddingLeft
      }),
      setMinLength: minLength => this.setState({
        minLength
      }),
      isEventTarget: e => e && e.target === e.currentTarget
    });
  }

  static getDerivedStateFromProps(props, state) {
    const willUpdateStates = {};

    if (props.value !== state.cachedValue) {
      willUpdateStates.value = props.value;
      willUpdateStates.cachedValue = props.value;
    }

    return willUpdateStates;
  }

  componentDidUpdate(prevProps) {
    const {
      mode
    } = this.props;

    if (prevProps.mode !== mode) {
      this.handleModeChange(mode);
    }
  }

  renderPrepend() {
    const {
      addonBefore
    } = this.props;

    if (addonBefore) {
      const prefixWrapperCls = cls({
        ["".concat(prefixCls, "-prepend")]: true,
        ["".concat(prefixCls, "-prepend-text")]: addonBefore && _isString(addonBefore),
        ["".concat(prefixCls, "-prepend-icon")]: isSemiIcon(addonBefore)
      });
      return /*#__PURE__*/React.createElement("div", {
        className: prefixWrapperCls
      }, addonBefore);
    }

    return null;
  }

  renderAppend() {
    const {
      addonAfter
    } = this.props;

    if (addonAfter) {
      const prefixWrapperCls = cls({
        ["".concat(prefixCls, "-append")]: true,
        ["".concat(prefixCls, "-append-text")]: addonAfter && _isString(addonAfter),
        ["".concat(prefixCls, "-append-icon")]: isSemiIcon(addonAfter)
      });
      return /*#__PURE__*/React.createElement("div", {
        className: prefixWrapperCls
      }, addonAfter);
    }

    return null;
  }

  renderClearBtn() {
    const clearCls = cls("".concat(prefixCls, "-clearbtn"));
    const allowClear = this.foundation.isAllowClear(); // use onMouseDown to fix issue 1203

    if (allowClear) {
      return /*#__PURE__*/React.createElement("div", {
        role: "button",
        tabIndex: 0,
        "aria-label": "Clear input value",
        className: clearCls,
        onMouseDown: this.handleClear,
        onKeyPress: this.handleClearEnterPress
      }, /*#__PURE__*/React.createElement(IconClear, null));
    }

    return null;
  }

  renderModeBtn() {
    const {
      value,
      isFocus,
      isHovering,
      eyeClosed
    } = this.state;
    const {
      mode,
      disabled
    } = this.props;
    const modeCls = cls("".concat(prefixCls, "-modebtn"));
    const modeIcon = eyeClosed ? /*#__PURE__*/React.createElement(IconEyeClosedSolid, null) : /*#__PURE__*/React.createElement(IconEyeOpened, null);
    const showModeBtn = mode === 'password' && value && !disabled && (isFocus || isHovering);
    const ariaLabel = eyeClosed ? 'Show password' : 'Hidden password';

    if (showModeBtn) {
      return /*#__PURE__*/React.createElement("div", {
        role: "button",
        tabIndex: 0,
        "aria-label": ariaLabel,
        className: modeCls,
        onClick: this.handleClickEye,
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onKeyPress: this.handleModeEnterPress
      }, modeIcon);
    }

    return null;
  }

  renderPrefix() {
    const {
      prefix,
      insetLabel,
      insetLabelId
    } = this.props;
    const labelNode = prefix || insetLabel;

    if (!labelNode) {
      return null;
    }

    const prefixWrapperCls = cls({
      ["".concat(prefixCls, "-prefix")]: true,
      ["".concat(prefixCls, "-inset-label")]: insetLabel,
      ["".concat(prefixCls, "-prefix-text")]: labelNode && _isString(labelNode),
      ["".concat(prefixCls, "-prefix-icon")]: isSemiIcon(labelNode)
    }); // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions

    return /*#__PURE__*/React.createElement("div", {
      className: prefixWrapperCls,
      onMouseDown: this.handlePreventMouseDown,
      onClick: this.handleClickPrefixOrSuffix,
      id: insetLabelId
    }, labelNode);
  }

  showClearBtn() {
    const {
      value,
      isFocus,
      isHovering
    } = this.state;
    const {
      disabled,
      showClear
    } = this.props;
    return Boolean(value) && showClear && !disabled && (isFocus || isHovering);
  }

  renderSuffix(suffixAllowClear) {
    const {
      suffix,
      hideSuffix
    } = this.props;

    if (!suffix) {
      return null;
    }

    const suffixWrapperCls = cls({
      ["".concat(prefixCls, "-suffix")]: true,
      ["".concat(prefixCls, "-suffix-text")]: suffix && _isString(suffix),
      ["".concat(prefixCls, "-suffix-icon")]: isSemiIcon(suffix),
      ["".concat(prefixCls, "-suffix-hidden")]: suffixAllowClear && Boolean(hideSuffix)
    }); // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions

    return /*#__PURE__*/React.createElement("div", {
      className: suffixWrapperCls,
      onMouseDown: this.handlePreventMouseDown,
      onClick: this.handleClickPrefixOrSuffix
    }, suffix);
  }

  render() {
    var _context, _context2;

    const _a = this.props,
          {
      addonAfter,
      addonBefore,
      autofocus,
      className,
      disabled,
      placeholder,
      prefix,
      mode,
      insetLabel,
      insetLabelId,
      validateStatus,
      type,
      readonly,
      size,
      suffix,
      style,
      showClear,
      onEnterPress,
      onClear,
      hideSuffix,
      inputStyle,
      forwardRef,
      maxLength,
      getValueLength
    } = _a,
          rest = __rest(_a, ["addonAfter", "addonBefore", "autofocus", "className", "disabled", "placeholder", "prefix", "mode", "insetLabel", "insetLabelId", "validateStatus", "type", "readonly", "size", "suffix", "style", "showClear", "onEnterPress", "onClear", "hideSuffix", "inputStyle", "forwardRef", "maxLength", "getValueLength"]);

    const {
      value,
      paddingLeft,
      isFocus,
      minLength: stateMinLength
    } = this.state;
    const suffixAllowClear = this.showClearBtn();
    const suffixIsIcon = isSemiIcon(suffix);
    const ref = forwardRef || this.inputRef;
    const wrapperPrefix = "".concat(prefixCls, "-wrapper");
    const wrapperCls = cls(wrapperPrefix, className, {
      ["".concat(prefixCls, "-wrapper__with-prefix")]: prefix || insetLabel,
      ["".concat(prefixCls, "-wrapper__with-suffix")]: suffix,
      ["".concat(prefixCls, "-wrapper__with-suffix-hidden")]: suffixAllowClear && Boolean(hideSuffix),
      ["".concat(prefixCls, "-wrapper__with-suffix-icon")]: suffixIsIcon,
      ["".concat(prefixCls, "-wrapper__with-append")]: addonBefore,
      ["".concat(prefixCls, "-wrapper__with-prepend")]: addonAfter,
      ["".concat(prefixCls, "-wrapper__with-append-only")]: addonBefore && !addonAfter,
      ["".concat(prefixCls, "-wrapper__with-prepend-only")]: !addonBefore && addonAfter,
      ["".concat(wrapperPrefix, "-readonly")]: readonly,
      ["".concat(wrapperPrefix, "-disabled")]: disabled,
      ["".concat(wrapperPrefix, "-warning")]: validateStatus === 'warning',
      ["".concat(wrapperPrefix, "-error")]: validateStatus === 'error',
      ["".concat(wrapperPrefix, "-focus")]: isFocus,
      ["".concat(wrapperPrefix, "-clearable")]: showClear,
      ["".concat(wrapperPrefix, "-modebtn")]: mode === 'password',
      ["".concat(wrapperPrefix, "-hidden")]: type === 'hidden',
      [_concatInstanceProperty(_context = "".concat(wrapperPrefix, "-")).call(_context, size)]: size
    });
    const inputCls = cls(prefixCls, {
      [_concatInstanceProperty(_context2 = "".concat(prefixCls, "-")).call(_context2, size)]: size,
      ["".concat(prefixCls, "-disabled")]: disabled,
      ["".concat(prefixCls, "-sibling-clearbtn")]: this.foundation.isAllowClear(),
      ["".concat(prefixCls, "-sibling-modebtn")]: mode === 'password'
    });
    const inputValue = value === null || value === undefined ? '' : value;

    const inputProps = _Object$assign(_Object$assign({}, rest), {
      style: _Object$assign({
        paddingLeft
      }, inputStyle),
      autoFocus: autofocus,
      className: inputCls,
      disabled,
      readOnly: readonly,
      type: this.foundation.handleInputType(type),
      placeholder: placeholder,
      onInput: e => this.foundation.handleInput(e),
      onChange: e => this.foundation.handleChange(e.target.value, e),
      onFocus: e => this.foundation.handleFocus(e),
      onBlur: e => this.foundation.handleBlur(e),
      onKeyUp: e => this.foundation.handleKeyUp(e),
      onKeyDown: e => this.foundation.handleKeyDown(e),
      onKeyPress: e => this.foundation.handleKeyPress(e),
      value: inputValue
    });

    if (!_isFunction(getValueLength)) {
      inputProps.maxLength = maxLength;
    }

    if (stateMinLength) {
      inputProps.minLength = stateMinLength;
    }

    if (validateStatus === 'error') {
      inputProps['aria-invalid'] = "true";
    }

    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      React.createElement("div", {
        className: wrapperCls,
        style: style,
        onMouseEnter: e => this.handleMouseOver(e),
        onMouseLeave: e => this.handleMouseLeave(e),
        onClick: e => this.handleClick(e)
      }, this.renderPrepend(), this.renderPrefix(), /*#__PURE__*/React.createElement("input", _Object$assign({}, inputProps, {
        ref: ref
      })), this.renderClearBtn(), this.renderSuffix(suffixAllowClear), this.renderModeBtn(), this.renderAppend())
    );
  }

}

Input.propTypes = {
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  'aria-invalid': PropTypes.bool,
  'aria-errormessage': PropTypes.string,
  'aria-describedby': PropTypes.string,
  'aria-required': PropTypes.bool,
  addonBefore: PropTypes.node,
  addonAfter: PropTypes.node,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  mode: PropTypes.oneOf(modeSet),
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  autofocus: PropTypes.bool,
  type: PropTypes.string,
  showClear: PropTypes.bool,
  hideSuffix: PropTypes.bool,
  placeholder: PropTypes.any,
  size: PropTypes.oneOf(sizeSet),
  className: PropTypes.string,
  style: PropTypes.object,
  validateStatus: PropTypes.oneOf(statusSet),
  onClear: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onInput: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onKeyPress: PropTypes.func,
  onEnterPress: PropTypes.func,
  insetLabel: PropTypes.node,
  insetLabelId: PropTypes.string,
  inputStyle: PropTypes.object,
  getValueLength: PropTypes.func
};
Input.defaultProps = {
  addonBefore: '',
  addonAfter: '',
  prefix: '',
  suffix: '',
  disabled: false,
  readonly: false,
  type: 'text',
  showClear: false,
  hideSuffix: false,
  placeholder: '',
  size: 'default',
  className: '',
  onClear: _noop,
  onChange: _noop,
  onBlur: _noop,
  onFocus: _noop,
  onInput: _noop,
  onKeyDown: _noop,
  onKeyUp: _noop,
  onKeyPress: _noop,
  onEnterPress: _noop,
  validateStatus: 'default'
};
const ForwardInput = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Input, _Object$assign({}, props, {
  forwardRef: ref
})));
export default ForwardInput;
export { Input };